import { createModalsFactory } from 'ui';

type CredentialCardModalIds = 'Detail' | 'Remove';

export const {
  Provider: CredentialCardModalProvider,
  useProvider: useCredentialCardModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<CredentialCardModalIds[]>(['Detail', 'Remove']);
